/**
 * Simulation runtime configuration.
 *
 * Centralizes tunable runtime behavior for exam simulation flows.
 *
 * @module simulationRuntimeConfig
 */

const DEFAULT_INACTIVITY_TIMEOUT_MINUTES = 5;

function parseTimeoutMinutes(rawValue: string | undefined): number {
  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_INACTIVITY_TIMEOUT_MINUTES;
  }
  return parsed;
}

/**
 * Inactivity timeout for simulation presence checks in minutes.
 * Tunable via `VITE_SIMULATION_INACTIVITY_MINUTES`.
 */
export const SIMULATION_INACTIVITY_TIMEOUT_MINUTES = parseTimeoutMinutes(
  import.meta.env.VITE_SIMULATION_INACTIVITY_MINUTES,
);

/**
 * Inactivity timeout for simulation presence checks in milliseconds.
 */
export const SIMULATION_INACTIVITY_TIMEOUT_MS = SIMULATION_INACTIVITY_TIMEOUT_MINUTES * 60 * 1000;
